import { MEMBERSHIPS } from 'common/constants'

const { VIP, GOLD } = MEMBERSHIPS

const intervalUnits = {
  // used in VIP addon text - EN only atm
  L: 'Lifetime',
  Y: 'Year',
  M: 'Month',
  W: 'Week',
  D: 'Day',
  H: 'Hour',
  MI: 'Minute',
  O: 'Once',
  N: 'Never',
  A: 'Auto Prolongating',
}

export const memberships = {
  one: (ms = {}) => ({
    ...ms,
    name: ms.subscriptionName.replace(/<\/?big>/g, ''),
    price: {
      currency: ms.currencySymbolToDisplay,
      value: parseFloat(ms.pricePerPeriodToDisplay).toFixed(2),
      period: intervalUnits[ms.intervalUnit],
      total: parseFloat(ms.fullAmountToDisplay).toFixed(2),
    },
    discount: ms.discount,
  }),

  many: items => ({
    gold: items.filter(m => m.membershipId == GOLD).map(memberships.one),
    vip: memberships.one(items.find(m => m.membershipId == VIP)),
  }),
}
